import * as HoverCard from '@radix-ui/react-hover-card';
import { Palette, Warehouse } from 'lucide-react';

import { Button } from 'components/ui/button';
import { statusVisuals } from '../../statusVisuals';
import * as S from '../../styles';

const legendOptions = Object.values(statusVisuals);

export const StatusLegend = () => (
  <HoverCard.Root openDelay={100} closeDelay={100}>
    <HoverCard.Trigger asChild>
      <Button
        type="button"
        variant="outline"
        size="sm"
        aria-label="Legenda de cores dos status"
        className="flex h-9 rounded-md border-slate-300 bg-white px-4 text-xs text-slate-700 hover:bg-gray-50 hover:text-slate-800"
      >
        <Palette className="mr-2 h-4 w-4" aria-hidden />
        Legenda
      </Button>
    </HoverCard.Trigger>
    <HoverCard.Portal>
      <S.StatusLegendContent sideOffset={6} align="end">
        {legendOptions.map(({ label, color }) => (
          <S.StatusLegendItem key={label}>
            <S.StatusDot role="img" aria-label={label} color={color} />
            <span>{label}</span>
          </S.StatusLegendItem>
        ))}
        <S.StatusLegendItem>
          <S.PhysicalDockBadge
            role="img"
            aria-label="Doca física definida"
            $highlighted={false}
          >
            <Warehouse aria-hidden="true" size={12} />
          </S.PhysicalDockBadge>
          <span>Doca física definida</span>
        </S.StatusLegendItem>
        <S.StatusLegendItem>
          <S.StatusLegendOrderTypeBadge role="img" aria-label="Carregamento">
            C
          </S.StatusLegendOrderTypeBadge>
          <span>C — Carregamento</span>
        </S.StatusLegendItem>
        <S.StatusLegendItem>
          <S.StatusLegendOrderTypeBadge role="img" aria-label="Descarregamento">
            D
          </S.StatusLegendOrderTypeBadge>
          <span>D — Descarregamento</span>
        </S.StatusLegendItem>
      </S.StatusLegendContent>
    </HoverCard.Portal>
  </HoverCard.Root>
);
